<template>
  <el-radio-group class="exam-checkbox-radio-box" v-model="checkValue[subjects.examQuestionsId]" :disabled="readOnly" @change="handleCheck">
    <el-radio v-for="item in subjects.options" :key="item.examQuestionsOptionsId" :label="item.examQuestionsOptionsId + '[-]' + item.name">
      <span>
        {{ item.option }}.{{ item.name }}
        <div class="img" v-if="item.imgs">
          <template v-for="(img, i) in item.imgs">
            <el-popover
              placement="right"
              trigger="hover"
              width="200"
              :popper-options="{ boundariesElement: 'viewport', removeOnDestroy: true }"
              :key="i"
            >
              <el-image :src="dsf.url.getWebPath(optionImg)">
                <div slot="error" class="image-slot">
                  <i class="iconfont icon-tupianjiazaishibai err-img"></i>
                </div>
              </el-image>
              <el-image slot="reference" :key="i" :src="dsf.url.getWebPath(img.relativePath)" @mouseover="showPopver" @click="showImage(item)">
                <div slot="error" class="image-slot">
                  <i class="iconfont icon-tupianjiazaishibai err-img"></i>
                </div>
              </el-image>
            </el-popover>
          </template>
        </div>
      </span>

      <i
        :class="[
          'iconfont right-icon',
          previewStatus && readOnly && subjects.result
            ? subjects.result.indexOf(item.examQuestionsOptionsId) > -1
              ? subjects.answer.indexOf(item.examQuestionsOptionsId) > -1
                ? 'icon-icon_gou'
                : 'icon-icon_wrong'
              : ''
            : 'icon-icon_gou',
        ]"
      ></i>
    </el-radio>
  </el-radio-group>
</template>

<script>
export default dsf.component({
  name: "DsfExamRadioBox",
  mixins: [$mixins.examControl],
  ctrlCaption: "单选题",
  props: {
    previewStatus: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: true,
    },
    metadata: {
      type: Object,
      default() {
        return dsf.metadata.get("exam-items-meta-data");
      },
    },
  },
  data() {
    return {
      optionImg: "",
    };
  },
  created() {},
  methods: {
    showImage(item) {
      this.$emit("show-image", item.imgs);
    },
    showPopver(e) {
      this.$nextTick(() => {
        if (e.target.nodeName.toLowerCase() === "img") {
          // this.$refs.popoverimg.updatePopper(); // 用来重新计算位置
          this.optionImg = e.target.src;
        } else {
          this.optionImg = false;
        }
      });
    },
  },
});
</script>
